import { clientbookApi } from '../core/clientbook-api';

// available params: limit, offset, sort, storeId
export const getClientSales = async (clientId, { params = {} }) => {
  const data = await clientbookApi.get({
    url: `/clients/${clientId}/sales`,
    query: { offset: 0, ...params },
  });
  return { data };
};

// available params: limit, offset, sort, storeId, direction, delivered
export const getClientMessages = async (clientId, { params = {} }) => {
  const data = await clientbookApi.get({
    url: `/clients/${clientId}/messages`,
    query: { offset: 0, ...params },
  });
  return { data };
};
